<template>
  <div class="main">
    <nav-bar title="我的参与记录"></nav-bar>
    <van-pull-refresh
      v-if="list.length"
      class="scroll"
      v-model="refreshing"
      @refresh="onRefresh"
    >
      <van-list
        class="list"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        error-text="发生异常，请刷新！"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="item" v-for="(item, i) of list" :key="i">
          <div class="top">
            <span>开奖时间：{{ item._date }}</span>
            <span v-if="item.status == 1" class="status">未中奖</span>
            <span v-else-if="item.status == 2" class="status red">已中奖</span>
            <span v-else-if="item.status == 3" class="status"
              >未中奖，券已返还</span
            >
            <span v-else class="status ornage">待开奖</span>
          </div>
          <div v-if="item.lucky_draw" class="goods">
            <img :src="item.lucky_draw.image" alt="" class="icon" />
            <div class="info">
              <div class="title">{{ item.lucky_draw.name }}</div>
              <span class="num">{{ item.ticket }}张</span>
            </div>
          </div>
          <div v-if="item.status == 3" class="desc">
            {{ item.lucky_draw.close_reason }}
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <div v-else class="empty">
      <img src="@/assets/lucky/empty-2.png" alt="" class="icon" />
      <span class="desc">暂无记录</span>
    </div>
  </div>
</template>

<script>
import mixin from "./mixin";
import NavBar from "./components/navbar.vue";
import { getFmtDate } from "./utils";

export default {
  mixins: [mixin],
  components: {
    NavBar,
  },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      error: false,
      page: 0,
      list: [],
    };
  },
  created() {
    this.onRefresh();
  },
  methods: {
    onRefresh() {
      this.finished = false;
      this.error = false;
      this.loading = true;
      this.page = 0;
      this.onLoad();
    },
    onLoad() {
      if (this.finished) {
        return;
      }
      if (!this.refreshing) {
        this.loading = true;
      }
      this.$api
        .post("activity/member/lucky/record", {
          page: ++this.page,
          pageSize: 20,
        })
        .then((res) => {
          res.list = res.list.map((_) => {
            _._date = getFmtDate(_.lucky_draw.lottery_time, "Y-m-d");
            return _;
          });
          if (this.page == 1) {
            this.list = res.list;
          } else {
            this.list = this.list.concat(res.list);
          }
          console.log("参与记录", this.list);
          this.finished = res.current_page >= res.last_page;
        })
        .catch((e) => (this.error = true))
        .finally(() => {
          this.loading = false;
          this.refreshing = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 100vh;
  font-size: 1.4rem;
  background: #f5f6f7;
  display: flex;
  flex-direction: column;
}

.scroll {
  flex: 1;
  padding: 2rem 1.2rem;
  overflow: auto;

  .item {
    margin-top: 1.2rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 1.1rem 0;
    border-radius: 0.8rem;

    &:first-of-type {
      margin-top: 0;
    }

    .top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #666666;
      padding: 0 1.2rem;

      .status {
        color: #999999;
        font-weight: 700;

        &.ornage {
          color: #f9591b;
        }

        &.red {
          color: #f9305b;
        }
      }
    }

    .goods {
      margin-top: 1rem;
      display: flex;
      align-items: stretch;
      padding: 0 1.2rem;

      .icon {
        flex: 0 0 6.6rem;
        height: 6.6rem;
        margin-right: 1rem;
      }

      .info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
          font-size: 1.5rem;
          font-weight: 700;
          line-height: 2rem;
          max-height: 4rem;
          display: -webkit-box;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .num {
          font-size: 1.2rem;
          color: #666666;
        }
      }
    }

    .desc {
      margin-top: 1.2rem;
      border-top: 0.1rem solid #e5e5e5;
      padding: 1rem 1.2rem 0;
    }
  }
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 7.5rem 0;

  .icon {
    width: 28.1rem;
    height: 11rem;
    margin-bottom: 3.2rem;
  }

  .desc {
    color: #666666;
  }
}
</style>
